import { createContext, useContext } from 'react'

export const TimeDifference = createContext<number>(null)

export function useTimeDifference(): number {
    return useContext(TimeDifference)
}
